import isServer from './isServer'

const sendSegmentEvent = (eventName, data) => {
  if (isServer) {
    return
  }
  // eslint-disable-next-line no-unused-expressions
  window.analytics?.track(eventName, data)
}

export default sendSegmentEvent
